import { render, staticRenderFns } from "./sysRoomBoard.vue?vue&type=template&id=8cf53b5a&"
import script from "./sysRoomBoard.vue?vue&type=script&lang=js&"
export * from "./sysRoomBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports